// store pages render client-side (routeRules), so this runs in the browser with the session cookie
export default defineNuxtRouteMiddleware(async function requirePlatformSession() {
    const authClient = useAuthClient()
    const {data} = await authClient.getSession()
    if (!data) {
        return navigateTo(useLocalePath()('/login'))
    }
})
